import React from 'react';
import { useNavigate } from 'react-router-dom';

const PLACEHOLDER = '/placeholder-product.png';

export default function ProductCard({ product }) {
  const navigate = useNavigate();
  const img = product?.images?.[0]?.src || PLACEHOLDER;
  const name = product?.name || 'Prodotto';

  return (
    <>
      <style>{`
        .product-card {
          position: relative;
          background: #181818;
          cursor: pointer;
          overflow: hidden;
          transition: transform 0.2s;
        }
        .product-card:hover { transform: scale(1.02); }
        .product-card img {
          width: 100%;
          aspect-ratio: 1 / 1;
          object-fit: cover;
          display: block;
          background: #181818;
        }
        .product-card-badge {
          position: absolute;
          bottom: 0; left: 0;
          background: #d71921;
          color: #fff;
          font-family: 'Alumni Sans', sans-serif;
          font-weight: 600;
          font-size: 16px;
          padding: 8px 14px;
          width: 70%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      `}</style>
      <div className="product-card" onClick={() => navigate(`/prodotto/${product.id}`)}>
        <img src={img} alt={name} />
        <div className="product-card-badge">{name}</div>
      </div>
    </>
  );
}
